import $ from 'jquery';

$(function(){

  $('.js-c-TVCM__itemThum').on('click', function(){
    var id = $(this).data();
    var url = 'https://www.youtube.com/embed/' + id.video + '?autoplay=1';
    var $iframe = $(this).prev();
    $('.js-c-TVCM__itemThum').show();
    $('.js-c-TVCM__itemVideo').html('');
    $iframe.html('<iframe width="560" height="315" src="' + url + '" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>');

    $(this).fadeOut();

  });

});
